import {LitElement, svg, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {getValueOfFeature} from '../../../util/values';
import {selectHasBuriedBase, selectHeightDecided, selectIsBollard, selectIsOnesided, selectMeasures, selectModulePosPx} from '../../../selectors';

@customElement('svg-measure')
export class SvgMeasure extends connect(store)(LitElement) {

	static styles = css`
	  :host {

	  }
	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.decisions = state.decisions.data;
		this.status = state.status;
	}

	render() {
		const s = this.state;

		const measureLeftTpl = (data) => (when(!data.hidden, () => svg`
			<g transform="translate(5, ${data.top})">
				<line x1="33" y1="0"              x2="33" y2="${data.height}" stroke="#1D1D1B" stroke-width="0.5"></line>

				<line x1="30" y1="0"              x2="36" y2="0"              stroke="#1D1D1B" stroke-width="0.5"></line>
				<line x1="30" y1="${data.height}" x2="36" y2="${data.height}" stroke="#1D1D1B" stroke-width="0.5"></line>

				<text fill="#1D1D1B" fill-rule="nonzero" font-family="Helvetica" font-size="7" font-weight="normal" text-anchor="end">
					<tspan x="30" y="${data.height/2 - 2}">${data.label}</tspan>
				</text>
				<text fill="#6F6F6F" fill-rule="nonzero" font-family="Helvetica" font-size="7" font-weight="normal" text-anchor="end">
					<tspan x="30" y="${data.height/2 + 5}">${data.mm}</tspan>
				</text>
			</g>`));

		const measureRightTpl = (data) => (when(!data.hidden, () => svg`
			<g transform="translate(80, ${data.top})">
				<line x1="3" y1="0"              x2="3" y2="${data.height}" stroke="#1D1D1B" stroke-width="0.5"></line>

				<line x1="0" y1="0"              x2="6" y2="0"              stroke="#1D1D1B" stroke-width="0.5"></line>
				<line x1="0" y1="${data.height}" x2="6" y2="${data.height}" stroke="#1D1D1B" stroke-width="0.5"></line>

				<text fill="#1D1D1B" fill-rule="nonzero" font-family="Helvetica" font-size="7" font-weight="normal">
					<tspan x="7" y="${data.height/2 - 2}">${data.label}</tspan>
				</text>
				<text fill="#6F6F6F" fill-rule="nonzero" font-family="Helvetica" font-size="7" font-weight="normal">
					<tspan x="7" y="${data.height/2 + 5}">${data.mm}</tspan>
				</text>
			</g>`));
		const doorTpl = (data) => (when(!data.hidden, () => svg`
				<rect width="${selectIsBollard(s)?2.5:8}" height="${data.height}" stroke="#000000" stroke-width="0.5" transform="translate(${selectIsBollard(s)?54:56.5},${data.top})"/>
		`));

		const measures = selectMeasures(s);
		const svgPath = this.status.host + this.status.baseUrl + '/visuals/line-measure.svg';
		return svg`
			<svg class="drawing" width="120px" height="639px" viewBox="0 0 120 639" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
				<g id="LineSVG" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">

				${measureLeftTpl(measures.l)}

				${measureRightTpl(measures.l1)}
				${measureRightTpl(measures.l2)}
				${measureRightTpl(measures.l3)}
				${measureRightTpl(measures.l4)}
				${measureRightTpl(measures.l5)}

				${measureRightTpl(measures.p4)}
				${measureRightTpl(measures.p3)}
				${measureRightTpl(measures.p2)}
				${measureRightTpl(measures.p1)}

				${measureRightTpl(measures.u)}

				${doorTpl(measures.p4)}
				${doorTpl(measures.p2)}

				<use href="${svgPath}#${getValueOfFeature('HS_HousingType', this.decisions)}_${getValueOfFeature('HS_HousingHeight', this.decisions)}"></use>

				${when(selectHeightDecided(s), () => svg`
					<use href="${svgPath}#L${getValueOfFeature('LE_LightEngineModuleSize_1', this.decisions)}_1" y="${measures.l2.top}"></use>
					${when(!selectIsOnesided(s), () => svg`
						<use href="${svgPath}#L${getValueOfFeature('LE_LightEngineModuleSize_2', this.decisions)}_2" y="${selectIsBollard(s)?measures.l2.top:measures.l4.top}"></use>
					`)}
				`)}
				<use href="${svgPath}#${getValueOfFeature('HS_Base', this.decisions)}"></use>
				</g>
			</svg>
		`;
	}
}
